import {
  RESPONSIVE_GRID_SINGLE_COLUMN_BREAKPOINT_PX,
  RESPONSIVE_GRID_SINGLE_COLUMN_CLASS_NAME,
  RESPONSIVE_GRID_SINGLE_COLUMN_CONTENTS_CLASS_NAME,
  RESPONSIVE_GRID_SINGLE_COLUMN_ORDER_CLASS_NAMES,
} from '../constants/responsive-grid-layout';

export const DASHBOARD_ONE_COLUMN_BREAKPOINT_PX = RESPONSIVE_GRID_SINGLE_COLUMN_BREAKPOINT_PX;

export const DASHBOARD_GRID_CLASS_NAME =
  `grid w-full max-w-[1560px] grid-cols-[minmax(0,1fr)_minmax(0,1fr)] items-start gap-5 ${RESPONSIVE_GRID_SINGLE_COLUMN_CLASS_NAME}`;

export const DASHBOARD_COLUMN_CLASS_NAME =
  `flex min-w-0 flex-col gap-5 ${RESPONSIVE_GRID_SINGLE_COLUMN_CONTENTS_CLASS_NAME}`;

export const DASHBOARD_SECTIONS_IN_ONE_COLUMN_ORDER = [
  'todaySummary',
  'reviewInquiry',
  'orderSituation',
  'amountInfo',
  'newsBriefing',
  'blogPreview',
  'sellerboxAi',
] as const;

export type DashboardSection = (typeof DASHBOARD_SECTIONS_IN_ONE_COLUMN_ORDER)[number];

const [
  todaySummaryOrderClassName,
  reviewInquiryOrderClassName,
  orderSituationOrderClassName,
  amountInfoOrderClassName,
  newsBriefingOrderClassName,
  blogPreviewOrderClassName,
  sellerboxAiOrderClassName,
] = RESPONSIVE_GRID_SINGLE_COLUMN_ORDER_CLASS_NAMES;

export const dashboardSectionClassNames: Record<DashboardSection, string> = {
  todaySummary: todaySummaryOrderClassName,
  reviewInquiry: reviewInquiryOrderClassName,
  orderSituation: orderSituationOrderClassName,
  amountInfo: amountInfoOrderClassName,
  newsBriefing: newsBriefingOrderClassName,
  blogPreview: blogPreviewOrderClassName,
  sellerboxAi: sellerboxAiOrderClassName,
};
